import { ITaskFromServer } from "api/services/tasks/models"
import { INotificationHistory } from "./reducer";
import { TaskStatusesList } from "api/services/tasks/models";

export const tasksAdapter = (tasks: Array<ITaskFromServer>): INotificationHistory[] => {
    return tasks.map((task: ITaskFromServer) => {
        return {
            title: task.name,
            createdAt: task.createdAt,
            status: task.status ? TaskStatusesList[task.status] : TaskStatusesList["1"],
            id: task.id,
            progress: task.progress,
            updatedAt: task.updatedAt
        }
    })
}